import React from 'react';
import { RiFileExcel2Fill } from 'react-icons/ri';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import { urlServidor } from '../../../helpers';
import { NetworkError } from '../../../_layout/genericComponents/Metodos';
import { handleAlertGeneric } from '../../../_layout/helpers/handles';
import { info, primary, success, danger } from '../../../_layout/helpers/colores';

/*  Botones "Generar Layout" y "Cargar Layout" de las partidas de una solicitud.
    Solo en estos subramos (el servidor arma un layout distinto para cada uno);
    los demás que comparten formulario no tienen layout. */
const SUBRAMOS_CON_LAYOUT = [
    'AUTOMÓVILES RESIDENTES',
    'EQUIPO ELECTRÓNICO',
    'EQUIPO ELECTRONICO',
    'EQUIPO DE CONTRATISTAS Y MAQ. PESADA',
    'GASTOS MÉDICOS MAYORES'
];

export const tieneLayoutPartidas = (subRamo) => SUBRAMOS_CON_LAYOUT.includes(String(subRamo || '').trim().toUpperCase());

function descargar(archivo, nombre) {
    let url = window.URL.createObjectURL(archivo);
    let a = document.createElement('a');
    a.href = url;
    a.download = nombre;
    a.click();
    a.remove();
}

async function enviar(ruta, campos, token) {
    let formdata = new FormData();
    Object.entries(campos).forEach(([campo, valor]) => formdata.append(campo, valor));
    return await fetch(`${urlServidor}/service/reportes/${ruta}`, { method: 'POST', headers: { token }, body: formdata });
}

/*  solSegFianID, subRamo, estatus y folio de la solicitud.
    onCargado: se llama después de cargar (para refrescar la tabla de partidas). */
export function botonesLayoutPartidas({ solSegFianID, subRamo, estatus, folio = '', token, setAlert, onCargado }) {
    if (!solSegFianID || !tieneLayoutPartidas(subRamo)) return [];

    const error = (descripcion) => setAlert({ title: "¡Una disculpa!", descripcion, tipo: danger, msjConfirmacion: "Aceptar", onConfirm: () => setAlert(null) });

    async function generarLayout() {
        setAlert({ title: "Espere...", descripcion: "Generando el layout de partidas", tipo: success, showConfirm: false });
        try {
            let response = await enviar('LayoutPartidasSolicitud', { solSegFianID }, token);
            if (!response.ok) {
                let { mensaje } = await response.json();
                throw new Error(mensaje);
            }
            descargar(await response.blob(), `LayoutPartidas${folio ? '_' + folio : ''}.xlsx`);
            setAlert(null);
        } catch ({ message }) {
            error(NetworkError(message));
        }
    }

    async function cargarLayout(archivo) {
        setAlert({ title: "Espere...", descripcion: "Cargando las partidas de la solicitud", tipo: success, showConfirm: false });
        try {
            let response = await enviar('CargarPartidasSolicitud', { solSegFianID, archivo }, token);
            let { error: conError, mensaje, errores = [], partidas } = await response.json();
            if (conError) {
                setAlert({
                    title: "No se cargaron las partidas",
                    descripcion: errores.length > 0
                        ? <>{mensaje}<br /><br />{errores.map((e, i) => <React.Fragment key={i}>{e}<br /></React.Fragment>)}</>
                        : mensaje,
                    tipo: danger, msjConfirmacion: "Aceptar", onConfirm: () => setAlert(null)
                });
                return;
            }
            if (onCargado) onCargado();
            setAlert({
                title: "Partidas cargadas",
                descripcion: `Se cargaron ${partidas} ${partidas === 1 ? "partida" : "partidas"} en la solicitud ${folio}`,
                tipo: success, msjConfirmacion: "Aceptar", onConfirm: () => setAlert(null)
            });
        } catch ({ message }) {
            error(NetworkError(message));
        }
    }

    function seleccionarArchivo() {
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = '.xlsx';
        input.onchange = ({ target: { files } }) => {
            let archivo = files && files[0];
            if (!archivo) return;
            handleAlertGeneric({
                setAlert,
                onCancel: () => setAlert(null),
                mensaje: {
                    title: "Cargar partidas",
                    descripcion: `Se eliminarán todas las partidas de la solicitud ${folio} y se agregarán las del archivo ${archivo.name}. ¿Desea continuar?`,
                    tipo: "warning", msjConfirmacion: "Cargar", msjCancelacion: "Cancelar"
                },
                onConfirm: () => cargarLayout(archivo)
            });
        };
        input.click();
    }

    let botones = [{
        icono: RiFileExcel2Fill,
        color: info,
        descripcion: "Generar Layout",
        disabled: { multiseleccion: true },
        onClick: () => generarLayout()
    }];
    // Como "Agregar": mismo permiso; además solo EN REDACCION (el servidor también lo valida)
    if (String(estatus || '').trim().toUpperCase() === 'EN REDACCION') {
        botones.push({
            accionID: [2],
            icono: CloudUploadIcon,
            color: primary,
            descripcion: "Cargar Layout",
            disabled: { multiseleccion: true },
            onClick: () => seleccionarArchivo()
        });
    }
    return botones;
}
